import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { XLarge } from '@outdoor-voices/ui';
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import windowWidth from '@outdoor-voices/ui/dist/utils/dom/windowWidth';
import { KEY_CODES, KEY_DOWN } from '@outdoor-voices/ui/dist/config/constants';
import addClass from '../../utils/dom/addClass';
import css from './HeroVideo.module.scss';
import Play from '../icons/Play';
import removeClass from '../../utils/dom/removeClass';
import useEventListener from '../../utils/hooks/useEventListener';
import Video from '../Video';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MOBILE_WIDTH = 767;
var NO_SCROLL = 'no-scroll';
var TRACK_OBJ = {
  kind: 'subtitles',
  label: 'english_subtitles'
}; // ov-nav-wrap

var HeroVideo = function HeroVideo(_ref) {
  var captionsFull = _ref.captionsFull,
      captionsLoop = _ref.captionsLoop,
      onClose = _ref.onClose,
      onOpen = _ref.onOpen,
      posterFullDesktop = _ref.posterFullDesktop,
      posterFullMobile = _ref.posterFullMobile,
      posterLoopDesktop = _ref.posterLoopDesktop,
      posterLoopMobile = _ref.posterLoopMobile,
      srcFullDesktop = _ref.srcFullDesktop,
      srcFullMobile = _ref.srcFullMobile,
      srcLoopDesktop = _ref.srcLoopDesktop,
      srcLoopMobile = _ref.srcLoopMobile;
  // refs
  var closeButton = /*#__PURE__*/React.createRef();
  var fullVideo = /*#__PURE__*/React.createRef();
  var loopVideo = /*#__PURE__*/React.createRef(); // state

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showVideo = _useState2[0],
      setShowVideo = _useState2[1];

  var _useState3 = useState(windowWidth()),
      _useState4 = _slicedToArray(_useState3, 2),
      width = _useState4[0],
      setWidth = _useState4[1]; // state derived vars


  var isMobile = MOBILE_WIDTH >= width;

  var openVideo = function openVideo() {
    addClass(document.body, NO_SCROLL);
    setShowVideo(true);

    if (fullVideo && fullVideo.current) {
      fullVideo.current.play();
    }

    if (closeButton && closeButton.current) {
      closeButton.current.focus();
    }

    onOpen();
  };

  var closeVideo = useCallback(function () {
    if (fullVideo && fullVideo.current) {
      fullVideo.current.pause();
    }

    removeClass(document.body, NO_SCROLL);
    setShowVideo(false);
    onClose();
  }, [fullVideo]);
  useEventListener('resize', function () {
    setWidth(windowWidth());
  });
  useEffect(function () {
    var onClick = function onClick(_ref2) {
      var target = _ref2.target;

      if (fullVideo && fullVideo.current && fullVideo.current.contains(target)) {
        return;
      }

      closeVideo();
    };

    var onKeyDown = function onKeyDown(_ref3) {
      var key = _ref3.key;

      if (key === KEY_CODES.ESC) {
        closeVideo();
      }
    };

    if (showVideo) {
      document.addEventListener('click', onClick);
      document.addEventListener(KEY_DOWN, onKeyDown);
    } else {
      document.removeEventListener('click', onClick);
      document.removeEventListener(KEY_DOWN, onKeyDown);
    }

    return function () {
      document.removeEventListener('click', onClick);
      document.removeEventListener(KEY_DOWN, onKeyDown);
    };
  }, [closeVideo, fullVideo, showVideo, loopVideo]);
  return /*#__PURE__*/_jsxs("section", {
    className: css.root,
    children: [/*#__PURE__*/_jsx(Video, {
      className: css.preview,
      preload: "metadata",
      poster: isMobile ? posterLoopMobile : posterLoopDesktop,
      videoRef: loopVideo,
      src: isMobile ? srcLoopMobile : srcLoopDesktop,
      track: _objectSpread(_objectSpread({}, TRACK_OBJ), {}, {
        src: captionsLoop
      })
    }), /*#__PURE__*/_jsx("div", {
      className: css.center,
      children: /*#__PURE__*/_jsx("button", {
        className: css.playButton,
        onClick: openVideo,
        type: "button",
        title: "Video Play Button",
        children: /*#__PURE__*/_jsx(Play, {})
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: cc([css.videoBox, _defineProperty({}, css.showVideoBox, showVideo)]),
      children: [/*#__PURE__*/_jsx("button", {
        className: css.closeButton,
        onClick: closeVideo,
        ref: closeButton,
        type: "button",
        title: "Video Close Button",
        children: /*#__PURE__*/_jsx(XLarge, {})
      }), /*#__PURE__*/_jsx(Video, {
        autoPlay: false,
        className: css.video,
        controls: true,
        controlsList: "nodownload",
        crossOrigin: "anonymous",
        muted: false,
        poster: isMobile ? posterFullMobile : posterFullDesktop,
        preload: "metadata",
        videoRef: fullVideo,
        src: isMobile ? srcFullMobile : srcFullDesktop,
        track: _objectSpread(_objectSpread({}, TRACK_OBJ), {}, {
          src: captionsFull
        })
      })]
    })]
  });
};

HeroVideo.defaultProps = {
  onClose: function onClose() {},
  onOpen: function onOpen() {}
};
HeroVideo.propTypes = {
  captionsFull: PropTypes.string.isRequired,
  captionsLoop: PropTypes.string.isRequired,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  posterFullDesktop: PropTypes.string.isRequired,
  posterFullMobile: PropTypes.string.isRequired,
  posterLoopDesktop: PropTypes.string.isRequired,
  posterLoopMobile: PropTypes.string.isRequired,
  srcFullDesktop: PropTypes.string.isRequired,
  srcFullMobile: PropTypes.string.isRequired,
  srcLoopDesktop: PropTypes.string.isRequired,
  srcLoopMobile: PropTypes.string.isRequired
};
export default HeroVideo;